import React from 'react'

const Header = () => {
  return (
    
      <nav>Get Ready To Complete Your Goal</nav>
    
  )
}

export default Header


